import { render, staticRenderFns } from "./AssetListCard.vue?vue&type=template&id=72048704"
import script from "./AssetListCard.vue?vue&type=script&lang=js"
export * from "./AssetListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports